<div class="modal-container">
  @if(isMobileDevice){
    <div class="rectangle-line-mobile-view mt-2" mat-dialog-close>
      <img src="../../../assets/images/rectangle-line.svg" />
    </div>
  }
  <mat-dialog-content class="modal-content">
    <div class="modal-heading">
      <div class="close-button" mat-button mat-dialog-close>
        <mat-icon class="close-icon">close</mat-icon>
      </div>
    </div>

    <div class="container">
      <div class="inner-container">
        <div class="image-container">
          <img src="/assets/images/success.svg" class="image" />
        </div>
      </div>
      <div class="text-container">
        <h1 class="title">{{ data.heading }}</h1>
      </div>
      <div class="form-actions" mat-dialog-close>
        <button class="save-button dp-primary-btn">Done</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
